export const BraintreePaypal = () => {
  return null
}
